import React from 'react';
import { useMobile } from '../../../hooks/useMobile';
import companyInfo from '../../../themes/themes';
import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';
import Card from '../Card';
import Item from './JourneyItem';
import Grid from '@material-ui/core/Grid';
import NoInfo from './NoInfo';

const useStyles = makeStyles((theme) => ({
  companyMemberSinceContainer: { display: 'flex', alignItems: 'center' },
  companyName: {
    borderRight: '1px solid black',
    paddingRight: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  noMarginTop: { marginTop: 0 },
  content: { fontSize: '1.3em' },
  topRight: { margin: 0 },
}));

export default function Journey(props) {
  const isMobile = useMobile();
  const classes = useStyles();
  const theme = process.env.REACT_APP_THEME;
  const { journey, company } = props;
  const haveCardInfo = Object.keys(journey).length > 0 ? true : false;

  return (
    <Card
      title={`My ${companyInfo[theme].company} Journey`}
      topRight={
        <h2 className={classes.topRight}>{moment().format('MMM D, YYYY')}</h2>
      }
    >
      <div className={classes.companyMemberSinceContainer}>
        {company.name && (
          <p className={classes.noMarginTop + ' ' + classes.companyName}>
            {company.name}
          </p>
        )}
        {journey.memberSince && (
          <p className={classes.noMarginTop}>
            Member since {journey.memberSince}
          </p>
        )}
      </div>
      {!haveCardInfo && <NoInfo />}
      {haveCardInfo && (
        <React.Fragment>
          <Grid
            container
            className={classes.content}
            justifyContent="space-between"
            direction="row"
            spacing={!isMobile ? 6 : undefined}
          >
            <Grid item xs={12} sm={6}>
              <Item
                label="Lines scheduled"
                number={journey.lines.active}
                bold={true}
              />
              <Item label="Lines completed" number={journey.lines.completed} />
              <Item label="Line drafts" number={journey.lines.draft} />
              <Item
                label="Submitted and pending plans"
                number={journey.pendingPlans + journey.submittedPlans}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Item label="Products" number={journey.products} />
              <Item
                label="Upcoming funds deliveries in next 2 weeks"
                number={journey.payments.upcoming}
              />
              <Item
                label="Completed funds deliveries"
                number={journey.payments.completed}
              />
              <Item
                label={
                  journey.accounts
                    ? 'Accounts verified'
                    : 'Unverified accounts. Verify now >'
                }
                accountsItem={true}
                accountsVerified={journey.accounts}
              />
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </Card>
  );
}
